import { render, staticRenderFns } from "./PlanningProducer.vue?vue&type=template&id=8d654990&"
import script from "./PlanningProducer.vue?vue&type=script&lang=js&"
export * from "./PlanningProducer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports